module.exports = __webpack_public_path__ + "img/animals.b3d99d72.svg";